import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { isBlank } from '@ember/utils';
export default class TodoItem extends Component {
    static{
        template(`
		<li class="{{if @todo.completed 'completed'}} {{if this.editing 'editing'}}">
			<div class="view">
				<input
					class="toggle"
					type="checkbox"
					aria-label="Toggle the completion state of this todo"
					checked={{@todo.completed}}
					{{on "change" this.toggleCompleted}}
				/>
				<label {{on "dblclick" this.startEditing}}>{{@todo.title}}</label>
				<button
					class="destroy"
					{{on "click" this.removeTodo}}
					type="button"
					aria-label="Delete this todo"
				></button>
			</div>
			<input
				class="edit"
				aria-label="Edit this todo"
				value={{@todo.title}}
				{{on "blur" this.doneEditing}}
				{{on "keydown" this.handleKeydown}}
				{{! template-lint-disable no-autofocus-attribute }}
				autofocus
			/>
		</li>
	`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @service
    repo;
    @tracked
    editing;
    removeTodo = ()=>this.repo.delete(this.args.todo);
    toggleCompleted = (event1)=>{
        this.args.todo.completed = event1.target.checked;
        this.repo.persist();
    };
    handleKeydown = (event1)=>{
        if (event1.keyCode === 13) {
            event1.target.blur();
        } else if (event1.keyCode === 27) {
            this.editing = false;
        }
    };
    startEditing = (event1)=>{
        this.args.onStartEdit();
        this.editing = true;
        event1.target.closest('li')?.querySelector('input.edit').focus();
    };
    doneEditing = (event1)=>{
        if (!this.editing) {
            return;
        }
        let todoTitle1 = event1.target.value.trim();
        if (isBlank(todoTitle1)) {
            this.removeTodo();
        } else {
            this.args.todo.title = todoTitle1;
            this.editing = false;
            this.args.onEndEdit();
        }
    };
}
